import { View, Text, StyleSheet } from '@react-pdf/renderer';

interface PdfCredentialDetailsProps {
  imageSource: any;
}

export const PdfSignatureArea: React.FC<PdfCredentialDetailsProps> = () => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '7px',
      fontFamily: 'Libre Franklin'
    },
    boldText: {
      fontSize: '8px',
      fontFamily: 'Libre Franklin Bold'
    },
    formInput: {
      width: '100%',
      borderTop: '1px solid black',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: 20
    },
    sealBox: {
      marginTop: 15,
      width: '100%',
      height: '120px',
      borderTop: '1px solid black',
      borderLeft: '1px solid black',
      borderRight: '1px solid black',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  });

  const SubSection: React.FC<{ text: string }> = ({ text }) => (
    <>
      <View style={styles.formInput}>
        <Text style={[styles.boldText, { textAlign: 'center', paddingTop: 2 }]}>{text}</Text>
      </View>
    </>
  );

  return (
    <>
      <View style={{ border: '1px solid black', marginLeft: '20px', marginRight: '20px', marginBottom: '10px' }}>
        <View style={{ borderBottom: '1px solid black', backgroundColor: 'e8e5ec' }}>
          <Text style={[styles.boldText, { padding: 5, fontSize: 8.7, backgroundColor: '#e8e5ec' }]}>
            I hereby certify that the attached credential is authentic and correct, and that I am authorized to certify this on behalf of my institution.
          </Text>
        </View>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <View style={{ fontSize: 10, textAlign: 'center', width: 30, height: 190, backgroundColor: '#e8e5ec' }}>
            <Text style={{ textAlign: 'center', transform: 'rotate(-90deg)', width: 100, marginLeft: -35, marginTop: 85 }}>CERTIFY</Text>
          </View>

          <View style={{ flexDirection: 'row', padding: 10, borderLeft: '1px solid black', gap: 15 }}>
            <View style={{ marginBottom: 5, width: 260 }}>
              <SubSection text={'Signature'}></SubSection>
              <SubSection text={'Printed Name'}></SubSection>
              <SubSection text={'Job title at institution'}></SubSection>
              <SubSection text={'Name of institution'}></SubSection>
              <SubSection text={'Email address at which you can be contacted'}></SubSection>
            </View>

            <View style={{ marginBottom: 5, width: 195 }}>
              <View style={{ width: '100%', borderTop: '1px solid black', flexDirection: 'column', justifyContent: 'center', marginTop: 20 }}>
                <Text style={[styles.boldText, { textAlign: 'center' }]}>Date of signature</Text>
                <View style={styles.sealBox}>
                  <Text style={[styles.text, { padding: '70 28 0 28', color: 'gray', textAlign: 'center' }]}>Place official institution seal/stamp above, if applicable</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>

      <View style={{ border: '1px solid black', marginLeft: '20px', marginRight: '20px', marginBottom: '10px' }}>
        <View style={{ borderBottom: '1px solid black', backgroundColor: '#e8e5ec' }}>
          <Text style={[styles.boldText, { padding: 5, fontSize: 8.7, backgroundColor: '#e8e5ec' }]}>
            I <Text style={{ textDecoration: 'underline' }}>cannot</Text> certify that the attached credential is authentic and correct due to the following reason(s) (attach
            additional sheet(s) if necessary):
          </Text>
        </View>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <View style={{ fontSize: 10, textAlign: 'center', width: 30, height: 190, backgroundColor: '#e8e5ec' }}>
            <Text style={{ textAlign: 'center', transform: 'rotate(-90deg)', width: 100, marginLeft: -35, marginTop: 85 }}>CANNOT CERTIFY</Text>
          </View>

          <View style={{ flexDirection: 'row', padding: 10, borderLeft: '1px solid black', gap: 15 }}>
            <View style={{ marginBottom: 5, width: 260 }}>
              <SubSection text={'Signature'}></SubSection>
              <SubSection text={'Printed Name'}></SubSection>
              <SubSection text={'Job title at institution'}></SubSection>
              <SubSection text={'Name of institution'}></SubSection>
              <SubSection text={'Email address at which you can be contacted'}></SubSection>
            </View>

            <View style={{ marginBottom: 5, width: 195 }}>
              <View style={{ width: '100%', borderTop: '1px solid black', flexDirection: 'column', justifyContent: 'center', marginTop: 20 }}>
                <Text style={[styles.boldText, { textAlign: 'center' }]}>Date of signature</Text>
                <View style={styles.sealBox}>
                  <Text style={[styles.text, { padding: '70 28 0 28', color: 'gray', textAlign: 'center' }]}>Place official institution seal/stamp above, if applicable</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default PdfSignatureArea;
